import dibsCss from 'dibs-css';
import classnames from 'classnames';
import { FunctionComponent } from 'react';

type LinkedinProps = {
    className?: string;
};

const Linkedin: FunctionComponent<LinkedinProps> = props => {
    return (
        <svg
            className={classnames(dibsCss.dibsIcon, props.className)}
            data-tn={'linkedin'}
            viewBox="0 0 500 500"
        >
            <path d="M463 0H36.9C16.5 0 0 16.2 0 36.1V464c0 19.8 16.5 36 36.9 36H463c20.4 0 37-16.2 37-36.1V36.1C500 16.2 483.3 0 463 0zM148.3 426.1H74.2V187.5h74.2v238.6zm-37.1-271.2c-23.8 0-43-19.3-43-43s19.3-43 43-43 43 19.3 43 43-19.3 43-43 43zm314.9 271.2h-74.2V310c0-27.6-.5-63.2-38.6-63.2-38.6 0-44.5 30.1-44.5 61.3v118.1h-74V187.5h71.1v32.6h1c9.9-18.8 34-38.6 70.1-38.6 75.1 0 88.9 49.4 88.9 113.7V426h.2z" />
        </svg>
    );
};
export default Linkedin;
